module.exports = __webpack_public_path__ + "static/screenshot-edgebundling-fecfe86366c5bf200dfa0176314a47e6.png";